const camelize = (s:string) => s.replace(/-./g, x=>x[1].toUpperCase())

// export default camelize
const sentenceize = (s:string) => `${s.charAt(0).toUpperCase()}${s.substring(1).toLowerCase()}`

export {
  camelize,
  sentenceize
}

